import { usePropertyServicePropertyLandProtectionsListKey } from '@insurance/api/queries'
import { PropertyService } from '@insurance/api/requests'
import { InfiniteSelect, InputParsedNumber } from '@shared/components'
import { Col, Form, Row, Select } from 'antd'
import { useTranslation } from 'react-i18next'

import { usePropertyInsuranceValues } from './PropertyInsuranceContext'

type Props = {
  fieldKey: number
}

export const ItemCategoryJFields = ({ fieldKey }: Props) => {
  const { t } = useTranslation()
  const { isEditable } = usePropertyInsuranceValues()

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} md={12}>
        <Form.Item name={[fieldKey, 'j', 'area']} label={t('area')}>
          <InputParsedNumber
            min={0}
            placeholder={t('area')}
            className="w-full"
            disabled={isEditable}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item name={[fieldKey, 'j', 'area_type']} label={t('area_type')}>
          <Select
            placeholder={t('area_type')}
            className="w-full"
            options={[
              { value: 'm2', label: 'm²' },
              { value: 'ha', label: t('ha') || 'ha' }
            ]}
            disabled={isEditable}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item
          name={[fieldKey, 'j', 'protections']}
          label={t('land_protection')}
        >
          <InfiniteSelect
            placeholder={t('land_protection')}
            className="w-full"
            mode="multiple"
            maxTagCount={3}
            apiCall={({ search, pageParam, pageSize }) =>
              PropertyService.propertyLandProtectionsList(
                undefined,
                pageParam,
                pageSize,
                search
              )
            }
            queryKey={[usePropertyServicePropertyLandProtectionsListKey]}
            getOption={(item) => ({
              value: item.code,
              label: item.name
            })}
            disabled={isEditable}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
